"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialImageKitValues = exports.IMAGE_KIT = void 0;
exports.IMAGE_KIT = "IMAGE_KIT";
exports.initialImageKitValues = { type: exports.IMAGE_KIT, status: "ACTIVE", data: { publicKey: "", privateKey: "", urlEndpoint: "" } };
